import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderCounterUpdatedEvent } from 'src/app/models/events/folder-counter-updated-event';

@Injectable()
export class FolderCounterEventsService {
    /**
     * Emis lorsque le compteur des dossiers affichés est mis à jour.
     */
    public displayedFoldersCounterUpdated = new Subject<FolderCounterUpdatedEvent>();

    /**
     * Emis lorsque le compteur total des dossiers est mis à jour.
     */
    public totalFoldersCounterUpdated = new Subject<FolderCounterUpdatedEvent>();
}
